/**
 * Shared vocabulary for where a cropped image keeps its focus. Values are the
 * CSS object-position / background-position keywords, applied verbatim — no
 * translation layer to drift.
 */
export type ImagePosition = "center" | "top" | "bottom" | "left" | "right";

export const IMAGE_POSITION_OPTIONS = [
  { label: "Center", value: "center" },
  { label: "Top", value: "top" },
  { label: "Bottom", value: "bottom" },
  { label: "Left", value: "left" },
  { label: "Right", value: "right" },
] as const;

/** Inline style for an <img> with object-cover; undefined when center (the CSS default). */
export function imagePositionStyle(
  position: string | undefined,
): { objectPosition: string } | undefined {
  if (!position || position === "center") {
    return undefined;
  }
  return { objectPosition: position };
}
